import { type ExitConfirmationModalProps, useIntl } from '@capsicum/common';

import { useInfoModal } from '../components/useInfoModal';
import { useRouter } from '../router/useCustomRouter';

export const useStepperConfirmationModal = () => {
	const { $t } = useIntl();
	const { back } = useRouter();
	const { showInfoModal } = useInfoModal();

	const openExitConfirmationModal = ({
		buttonCancel,
		buttonConfirm,
		description,
		onConfirmation,
		testID,
		title
	}: ExitConfirmationModalProps) => {
		showInfoModal({
			buttonOnHandlers: {
				onPrimaryButtonHandler: onConfirmation || back,
				secondaryInvokeOnDismiss: false
			},
			buttonTexts: {
				primaryButtonText: buttonConfirm || $t('global.button.confirm'),
				secondaryButtonText: buttonCancel
			},
			image: 'questionnaireAlert',
			subtitle: description || $t('kycUserIdentity.cancelModalDescription'),
			testID: `${testID}-exit-confirmation-modal`,
			title: title || $t('kycUserIdentity.cancelModalTitle'),
			variant: 'confirm'
		});
	};

	return {
		openExitConfirmationModal
	};
};
